var path = '/app/components/container/container.html';
var html = "<header class=main-header></header> <div class=content-wrapper fixed-height> <div class=container-fluid> <ui-view></ui-view> </div> </div> <footer class=main-footer></footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/container/container.html
// module id = 303
// module chunks = 0